import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, tap } from 'rxjs';
import {
  FrontEndToolPermissionGroup,
  UserUpdatePayload,
  UserReturn,
} from '../../../server/types';
import { HttpService } from './http.service';

@Injectable({ providedIn: 'root' })
export class UsersService {
  private userInfo = new Subject<UserReturn>();

  private permissionSubject = new BehaviorSubject<
    FrontEndToolPermissionGroup[]
  >([]);
  permissions$: Observable<FrontEndToolPermissionGroup[]> =
    this.permissionSubject.asObservable();

  constructor(private httpService: HttpService) {}

  getUsers() {
    return this.httpService.get<UserReturn[]>(`/users`);
  }

  updateUser(userId: number, payload: UserUpdatePayload) {
    return this.httpService.patch<UserReturn>(`/users/${userId}`, payload);
  }

  setUser(userInfo: UserReturn) {
    this.userInfo.next(userInfo);
  }

  getUser(): Observable<UserReturn> {
    return this.userInfo.asObservable();
  }

  getUserById(userId: number, query = {}) {
    return this.httpService.get<UserReturn>(`/users/${userId}`, query);
  }

  deleteUser(id: number) {
    return this.httpService.delete(`/users/${id}`);
  }

  getUserGroupedPermissionsList() {
    if (this.permissionSubject.getValue().length === 0) {
      return this.httpService
        .get<FrontEndToolPermissionGroup[]>(`/front-end-grouped-permissions`)
        .pipe(tap((permissions) => this.permissionSubject.next(permissions)));
    } else {
      return this.permissions$;
    }
  }
}
